export default __webpack_public_path__ + "static/media/746.357d36b5.png";